var _defs, _path, _g, _g2, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMhWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3252",
    "data-name": "Group 3252",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.85,
    height: 42.731,
    viewBox: "0 0 81.85 42.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    width: 81.85,
    height: 42.731,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2076",
    "data-name": "Rectangle 2076",
    width: 19.226,
    height: 16.567,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M341.832,100.613,350.05,92.4a6.417,6.417,0,0,1,9.075,0l.054.054a6.417,6.417,0,0,1,0,9.075l-3.68,3.68a6.417,6.417,0,0,1-9.075,0Z",
    transform: "translate(-341.832 -90.516)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.767,
    y1: 1.296,
    x2: -1.761,
    y2: 1.296,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aeb0b3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M104.617,100.613,96.4,92.4a6.417,6.417,0,0,0-9.075,0l-.054.054a6.417,6.417,0,0,0,0,9.075l3.68,3.68a6.417,6.417,0,0,0,9.075,0Z",
    transform: "translate(-85.391 -90.516)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.317,
    y1: 1.298,
    x2: -0.311,
    y2: 1.298,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3251",
    "data-name": "Group 3251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3249",
    "data-name": "Group 3249",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M87.271,24.238a6.417,6.417,0,0,1,0-9.075L100.554,1.879a6.417,6.417,0,0,1,9.075,0l4.116,4.116,4.116-4.116a6.417,6.417,0,0,1,9.075,0L140.22,15.163a6.417,6.417,0,0,1,0,9.075l-3.68,3.68a6.417,6.417,0,0,1-9.075,0l-4.591-4.591-4.591,4.591a6.417,6.417,0,0,1-9.075,0l-4.591-4.591-4.591,4.591a6.417,6.417,0,0,1-9.075,0Z",
    transform: "translate(-72.91 0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3243",
    "data-name": "Group 3243",
    transform: "translate(49.964 13.23)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3242",
    "data-name": "Group 3242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3241",
    "data-name": "Group 3241",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2075",
    "data-name": "Rectangle 2075",
    width: 26.423,
    height: 26.665,
    transform: "matrix(0.645, -0.764, 0.764, 0.645, -8.784, 9.778)",
    fill: "url(#linear-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3248",
    "data-name": "Group 3248",
    transform: "translate(12.481 13.23)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3247",
    "data-name": "Group 3247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3246",
    "data-name": "Group 3246",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3245",
    "data-name": "Group 3245",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3244",
    "data-name": "Group 3244",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2077",
    "data-name": "Rectangle 2077",
    width: 26.67,
    height: 26.584,
    transform: "translate(-9.521 7.75) rotate(-43.282)",
    fill: "url(#linear-gradient-2)"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M3.24,247.88l-1.526-4.929v4.929H0v-7.439H2.49L3.9,245l1.418-4.562h2.5v7.439H6.087v-4.929L4.531,247.88Z",
    transform: "translate(0 -205.297)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M59.307,243.252a3.9,3.9,0,0,1,1.735-3.191,3.813,3.813,0,0,1,2.118-.6,3.65,3.65,0,0,1,2.72,1.123,3.941,3.941,0,0,1,.056,5.4,3.849,3.849,0,0,1-5.518.059,3.839,3.839,0,0,1-1.11-2.79m1.883.02a2.091,2.091,0,0,0,.551,1.425,1.84,1.84,0,0,0,2.7.128,2.143,2.143,0,0,0,.1-2.927,1.84,1.84,0,0,0-1.4-.562,2.008,2.008,0,0,0-1.265.414,1.8,1.8,0,0,0-.684,1.522",
    transform: "translate(-50.638 -204.463)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M122.369,247.88l-2.781-4.143v4.143h-1.811v-7.439h1.653l2.719,4.133v-4.133h1.806v7.439Z",
    transform: "translate(-100.562 -205.297)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2079",
    "data-name": "Rectangle 2079",
    width: 1.811,
    height: 7.439,
    transform: "translate(24.588 35.144)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M189.551,242.161h-1.4v5.72h-1.822v-5.72h-1.393v-1.719h4.612Z",
    transform: "translate(-157.907 -205.297)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M218,243.252a3.9,3.9,0,0,1,1.735-3.191,3.813,3.813,0,0,1,2.117-.6,3.649,3.649,0,0,1,2.72,1.123,3.941,3.941,0,0,1,.056,5.4,3.849,3.849,0,0,1-5.518.059,3.839,3.839,0,0,1-1.11-2.79m1.883.02a2.091,2.091,0,0,0,.551,1.425,1.84,1.84,0,0,0,2.7.128,2.144,2.144,0,0,0,.1-2.927,1.84,1.84,0,0,0-1.4-.562,2.009,2.009,0,0,0-1.265.414,1.8,1.8,0,0,0-.684,1.522",
    transform: "translate(-186.133 -204.463)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M279.7,247.88l-1.428-2.393v2.393h-1.811v-7.439h2.47a3.772,3.772,0,0,1,1.827.383,1.925,1.925,0,0,1,.857.928,2.872,2.872,0,0,1,.214,1.158,2.38,2.38,0,0,1-1.7,2.439l1.822,2.531Zm-1.428-5.786v1.781a3.282,3.282,0,0,0,1.311-.179.89.89,0,0,0,.117-1.383,3.064,3.064,0,0,0-1.428-.219",
    transform: "translate(-236.055 -205.297)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2080",
    "data-name": "Rectangle 2080",
    width: 1.811,
    height: 7.439,
    transform: "translate(46.736 35.144)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M344.868,247.88l-2.781-4.143v4.143h-1.811v-7.439h1.653l2.719,4.133v-4.133h1.806v7.439Z",
    transform: "translate(-290.54 -205.297)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M391.652,244.348v-1.485h4.25a4.6,4.6,0,0,1-1.056,3.235,3.549,3.549,0,0,1-2.745,1.1,3.815,3.815,0,0,1-3.827-3.852,3.867,3.867,0,0,1,1.01-2.669,3.554,3.554,0,0,1,2.765-1.209,3.8,3.8,0,0,1,2.3.74,5.139,5.139,0,0,1,.587.526,3.959,3.959,0,0,1,.367.495,4.261,4.261,0,0,1,.388.8h-2.061a3.334,3.334,0,0,0-.74-.526,1.822,1.822,0,0,0-.775-.184,1.962,1.962,0,0,0-1.306.48,1.832,1.832,0,0,0-.653,1.475,2.026,2.026,0,0,0,.6,1.485,1.869,1.869,0,0,0,1.373.587,1.728,1.728,0,0,0,.8-.189,2.265,2.265,0,0,0,.847-.806Z",
    transform: "translate(-331.522 -204.464)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M451.254,244.493H447.7v3.388h-.745v-7.439h.745v3.327h3.556v-3.327h.709v7.439h-.709Z",
    transform: "translate(-381.624 -205.297)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M493.939,240.442h.745v4.72a3.48,3.48,0,0,1-.521,2.1,2.168,2.168,0,0,1-1.857.77,3.011,3.011,0,0,1-1.061-.158,1.768,1.768,0,0,1-.928-.8,3.872,3.872,0,0,1-.393-1.908v-4.72h.73v4.48a3.574,3.574,0,0,0,.26,1.495,1.409,1.409,0,0,0,.638.684,1.715,1.715,0,0,0,.776.163,1.386,1.386,0,0,0,1.189-.52,3.079,3.079,0,0,0,.423-1.822Z",
    transform: "translate(-418.313 -205.298)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M532.687,247.881h-1.643v-7.439h1.582a2.407,2.407,0,0,1,1.651.538,2.029,2.029,0,0,1,.4,2.348,1.667,1.667,0,0,1-.546.546,1.773,1.773,0,0,1,.842.661,1.877,1.877,0,0,1,.3,1.074,2.228,2.228,0,0,1-.536,1.592,2.714,2.714,0,0,1-2.051.679m-.934-6.735v2.51h.418a3.021,3.021,0,0,0,1.461-.26,1.114,1.114,0,0,0,.5-1.046,1.008,1.008,0,0,0-.413-.9,2.677,2.677,0,0,0-1.466-.306h-.5Zm0,3.194v2.832a6.6,6.6,0,0,0,2.2-.225,1.167,1.167,0,0,0,.586-1.191,1.273,1.273,0,0,0-.331-.961,1.74,1.74,0,0,0-.957-.383,11.31,11.31,0,0,0-1.5-.071",
    transform: "translate(-453.424 -205.298)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhWhiteLogo);
export default __webpack_public_path__ + "static/media/MH_WhiteLogo.79c478bd5d5ea5263df7d5ae448def5a.svg";
export { ForwardRef as ReactComponent };